import React, { Component } from 'react'

export default class videoicon extends Component {
    render() {
        return (
        
<svg className={this.props.className} onClick={this.props.onClick} width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="25.9887" cy="26.0512" r="25.3793" fill="url(#paint0_radial)" fill-opacity="0.15"/>
<circle cx="25.9889" cy="26.0514" r="18.4577" fill="#1063EA"/>
<path d="M31.6367 26.052L23.1073 31.8266L23.1073 20.2773L31.6367 26.052Z" fill="white"/>
<defs>
<radialGradient id="paint0_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(25.9887 26.0512) rotate(90) scale(25.3793)">
<stop offset="0.723958" stop-color="#1063EA" stop-opacity="0"/>
<stop offset="1" stop-color="#1063EA"/>
</radialGradient>
</defs>
</svg>
        )
    }
}
